import { useEffect, useState } from "react";
import { MapCard } from "@/components/map/MapCard";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { EmptyState } from "@/components/common/EmptyState";
import { ListOrdered } from "lucide-react";
import { Link } from "react-router-dom";

export default function JobsBoard() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);

  async function load() {
    const { data } = await api.get("/ballboy/open-jobs");
    setJobs(data.items || []);
  }

  useEffect(() => {
    load();
  }, []);

  async function accept(id) {
    try {
      await api.post(`/bookings/${id}/accept`);
      toast.success("Accepted");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not accept");
    }
  }

  const pins = jobs.map((j) => ({ lat: j.lat, lng: j.lng, variant: "athlete", label: j.sport }));
  const center = pins[0] ? [pins[0].lat, pins[0].lng] : [user?.lat || 40.758, user?.lng || -73.9855];

  return (
    <div className="space-y-3">
      <h2 className="text-xl font-semibold bb-display">Nearby jobs</h2>
      <MapCard center={center} pins={pins} height={220} />
      {jobs.length === 0 ? (
        <EmptyState
          icon={ListOrdered}
          title="No open jobs in range"
          description="Make sure you're online and have set your location. New jobs arrive instantly."
        />
      ) : (
        <div className="space-y-2">
          {jobs.map((j) => (
            <Card key={j.id}>
              <CardContent className="p-3">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="text-sm font-medium capitalize bb-display">{j.sport}</div>
                    <div className="text-xs text-muted-foreground">{new Date(j.start_at).toLocaleString()}</div>
                    <div className="text-xs text-muted-foreground">{j.address || `${j.lat.toFixed(3)}, ${j.lng.toFixed(3)}`}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-semibold tabular-nums">${j.price_total?.toFixed?.(2)}</div>
                    <div className="flex gap-1 mt-1">
                      <Link to={`/bookings/${j.id}`}><Button size="sm" variant="ghost">Details</Button></Link>
                      <Button size="sm" onClick={() => accept(j.id)} data-testid="ballboy-accept-job">Accept</Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
